import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Generiert Slug aus Name
export function generateSlug(name) {
  if (!name) return "";
  return name
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9-]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function formatCurrency(price, currency = "EUR", locale = "de-DE") {
  const n = Number(price || 0);
  const safeCurrency = String(currency || "EUR").toUpperCase();
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: safeCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(n) ? n : 0);
}

// Formatiert Preis in EUR (für konsistente Darstellung)
export function formatEUR(price) {
  const n = Number(price || 0);
  return `€${n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export { COUNTRY_PHONE_CODES, buildFullPhone } from './phone';

// Studio Public URL: custom domain wenn verifiziert, sonst /studio/{slug}
export function getStudioPublicUrl(location, origin = typeof window !== "undefined" ? window.location.origin : "") {
  if (!location) return "";
  if (location.custom_domain_verified && location.custom_domain) {
    return `https://${location.custom_domain}`;
  }
  return location.slug ? `${origin}/studio/${location.slug}` : "";
}
